import m from 'mithril';
import paymentSession from '../lib/paymentSession';

const vwAdyenConfirmation = {
	checkCount: 0,
	oninit: async ({ attrs: { redirectResult, sessionComplete = () => {}, sessionPending = () => {} } }) => {
		const checkStatus = async () => {
			const paymentCompleteCheck = await paymentSession.getSessionDetails({
				details: {
					redirectResult: redirectResult,
				},
			});

			if (paymentCompleteCheck.success === false || paymentCompleteCheck.data.resultCode === 'Pending') {
				vwAdyenConfirmation.checkCount++;

				if (vwAdyenConfirmation.checkCount === 3) {
					sessionPending();
					return;
				}

				setTimeout(checkStatus, vwAdyenConfirmation.checkCount * 5000);
			} else {
				sessionComplete();
			}
		};

		await checkStatus();
	},
	view: ({ attrs: { redirectResult, sessionComplete = () => {} } }) => {
		return vwAdyenConfirmation.checkCount == 3
			? m('div', { class: 'card__upper__content' }, [
					m('p', 'Failed to load payment'),
					m(
						'button',
						{
							class: 'btn',
							onclick: async () => {
								const paymentCompleteCheck = await paymentSession.getSessionDetails({
									details: {
										redirectResult: redirectResult,
									},
								});

								if (paymentCompleteCheck) {
									sessionComplete();
								}
							},
						},
						'Refresh'
					),
			  ])
			: '';
	},
};

export default vwAdyenConfirmation;
